import React from "react";
import "../../../style/common/_spinner.scss";

const  WaitLoading = ({top = 0, addClass = ""}) => {
  return (
    <div className={"loading-list " + addClass}>
      <div className={"loader loader-1"} style={{top: top}}></div>
    </div>
  )
}
export default WaitLoading;